// Shared read of the admin-managed home hero carousel.
// Used by the route loader (server render) and the client hook so the first
// banner is present in the initial HTML — no layout shift, no late discovery.
import { supabase } from "@/integrations/supabase/client";
import {
  DEFAULT_HERO_SETTINGS,
  type HeroCarouselSettings,
  type HeroSlide,
} from "@/lib/hero-carousel";

export type HeroCarouselData = { slides: HeroSlide[]; settings: HeroCarouselSettings };

export async function fetchHeroCarousel(): Promise<HeroCarouselData> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const db = supabase as any;
  const [slidesRes, settingsRes] = await Promise.all([
    db
      .from("hero_slides")
      .select("id, position, enabled, image_url, alt, link_path, cta_label, learn_label")
      .eq("enabled", true)
      .order("position"),
    db.from("hero_carousel_settings").select("autoplay, autoplay_ms").maybeSingle(),
  ]);
  return {
    slides: slidesRes.error ? [] : ((slidesRes.data ?? []) as HeroSlide[]),
    settings: settingsRes.error
      ? DEFAULT_HERO_SETTINGS
      : ((settingsRes.data as HeroCarouselSettings | null) ?? DEFAULT_HERO_SETTINGS),
  };
}
